<template>
  <div class="slice-page">
    <img v-if="!isPortrait" class="slice-bg" :src="preText + bgPc" />
    <img v-else class="slice-bg" :src="preText + bgMob" />
    <Swiper1 />
  </div>
</template>

<script>
import { isPortraitFun } from "@/utils/utils.js";
import Swiper1 from "@/components/aw2025/Swiper1";
import { getKiaBaseUrl } from "@/components/aw2025/swiper-common";

export default {
  components: { Swiper1 },
  data() {
    return {
      isPortrait: isPortraitFun(),
      preText: "https://www.kia.cn",
      bgPc: "/assets/~/media/images/activity/202604suchao/pc/swiper-bg.jpg",
      bgMob: "/assets/~/media/images/activity/202604suchao/mob/swiper-bg.jpg",
    };
  },
  mounted() {
    this.preText = getKiaBaseUrl();
    window.addEventListener("resize", this.setResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setResize);
  },
  methods: {
    setResize() {
      this.isPortrait = isPortraitFun();
    },
  },
};
</script>

<style lang="scss" scoped>
.slice-page {
  position: relative;
  width: 100%;
}

.slice-bg {
  display: block;
  width: 100%;
  margin-top: -1px;
}
@media (max-width: 767px) {
  .slice-bg {
    height: calc(3040 / 1500 * 100vw);
  }
  
}
@media (min-width: 767px) {
  .slice-bg {
    height: calc(1094 / 1920 * 100vw);
  }
}
</style>
